import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import request from '@/utils/api'
Vue.prototype.sApi = request

Vue.prototype.UpFileUrl = '/api/Upload/UploadFile'
Vue.prototype.ossUrl = 'https://jsg1.oss-cn-beijing.aliyuncs.com/'

import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
